module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="suvietat-customBar">\r\n  <div>\r\n    <a class="rafraichir" href="javascript:void(0)">\r\n      '+
((__t=(i18n.t('suvietat.rafraichir')))==null?'':__t)+
'\r\n    </a>\r\n  </div>\r\n</div><br/>\r\n';
}
return __p;
};
